import { useContext, useEffect, useState } from "react";
import "./pointsSettings.styles.scss";
import { LoyaltyContext } from "../../../../contexts/loyalty.context";
import {
  newPointInitial,
  handleChange,
  handleAddBox,
  newPointSubmit,
} from "./pointSettings.utils";
const PointsSettings = () => {
  const { pointsLoyalty, deleteFunction, addLoyalty, loyaltyDetails } =
    useContext(LoyaltyContext);
  const [newPointFields, setNewPointFields] = useState(newPointInitial);
  const [addBoxShow, setAddBoxShow] = useState(false);
  const { pointName, pointValue, pointExpiry } = newPointFields;

  return (
    <div className="points-settings-container">
      {Object.keys(pointsLoyalty).length === 0 ? (
        <div className="ps-noloyalty-container">
          {addBoxShow === false ? (
            <div className="ps-noloyalty-message">
              <span className="ps-noloyalty-title">
                You don't have loyalty points setup. Make visiting your
                restaurant rewarding for your customers with a few easy steps.
              </span>
              <span
                className="ps-newloyalty-button"
                onClick={() => handleAddBox(setAddBoxShow, true)}
              >
                &nbsp;Add loyalty point +&nbsp;
              </span>
            </div>
          ) : (
            <div className="ps-newloyalty-form">
              <form
                onSubmit={(event) =>
                  newPointSubmit(event, newPointFields, addLoyalty)
                }
              >
                <div className="ps-newloyalty-input-container">
                  <label className="ps-newloyalty-label">
                    Give your loyalty points a name
                  </label>
                  <input
                    type="text"
                    onChange={(event) =>
                      handleChange(event, setNewPointFields, newPointFields)
                    }
                    placeholder="Name"
                    name="pointName"
                    value={pointName}
                    className="ps-newloyalty-input"
                  />
                </div>
                <div className="ps-newloyalty-input-container">
                  <label className="ps-newloyalty-label">
                    How much are each points worth?
                  </label>
                  <input
                    type="text"
                    onChange={(event) =>
                      handleChange(event, setNewPointFields, newPointFields)
                    }
                    placeholder="Value"
                    name="pointValue"
                    value={pointValue}
                    className="ps-newloyalty-input"
                  />
                </div>
                <div className="ps-newloyalty-input-container">
                  <label className="ps-newloyalty-label">
                    How long can a customer use the point?
                    <br />
                    (in Months)
                  </label>
                  <input
                    type="number"
                    onChange={(event) =>
                      handleChange(event, setNewPointFields, newPointFields)
                    }
                    name="pointExpiry"
                    value={pointExpiry}
                    className="ps-newloyalty-input"
                  />
                </div>

                <div className="ps-newloyalty-buttons">
                  <button type="submit" className="ps-newloyalty-submit">
                    Add Point
                  </button>
                  <button
                    className="ps-newloyalty-cancel"
                    onClick={() => handleAddBox(setAddBoxShow, false)}
                  >
                    Go Back
                  </button>
                </div>
              </form>
            </div>
          )}
        </div>
      ) : (
        <div className="ps-loyalty-container">
          <div className="ps-loyalty-box">
            <div className="ps-loyalty-details">
              <span className="psl-details-title">Basic Details</span>
              <div className="psl-details">
                <span className="psl-name">
                  <span className="psl-tag">Point Name :</span>
                  <span className="psl-value-tag">
                    {loyaltyDetails["pointName"]}
                  </span>
                </span>
                <span className="psl-value">
                  <span className="psl-tag">Point Value : </span>
                  <span className="psl-value-tag">
                    {loyaltyDetails["pointValue"]}
                  </span>
                </span>
              </div>
            </div>
            <div className="ps-loyalty-expiry">
              <span className="psl-expiry-title">Loyalty point expiry</span>
              <div className="psl-expiry-box">
                <span className="psl-expiry-value">
                  <span className="psl-tag">Point Expiry : </span>
                  <span className="psl-value-tag">
                    {loyaltyDetails["pointExpiry"]} months
                  </span>
                </span>
              </div>
            </div>
          </div>

          <div className="psl-delete-container">
            <span
              className="psl-delete-button"
              onClick={() => {
                deleteFunction();
                setAddBoxShow(false);
                setNewPointFields(newPointInitial);
              }}
            >
              Delete Point
            </span>
          </div>
        </div>
      )}
    </div>
  );
};
export default PointsSettings;
